<template>
  <div>
    <b-modal
      ref="purchaseAgentsInvoiceCommissionFeeModal"
      :title="title"
      :no-close-on-backdrop="true">
      <b-row>
        <b-col>
          <p>{{$t('labels.common.actual_evaluation')}} ({{base_currency.code}}): {{invoiceData.actual_evaluation_cost}}</p>
        </b-col>
      </b-row>
      <b-row class="mt-0">
        <b-col>
          <span class="mr-2">m3: {{invoiceData.nom_m3}}</span>
          <span class="mr-2">m2: {{invoiceData.nom_m2}}</span>
          <span class="mr-2">lm: {{invoiceData.nom_lm}}</span>
          <span>pcs: {{invoiceData.nom_pcs}}</span>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <label>{{$t('labels.common.agent')}}</label>
        </b-col>
        <b-col>
          <multiselect v-model="commissionFee.agent" :max-height="200"
                       placeholder="" label="name" track-by="id"
                       :class="{ required: !commissionFee.agent}" @select="selectAgentCommissions"
                       :options="agents" :close-on-select="true"></multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <label>{{$t('labels.agents.commissions')}}</label>
        </b-col>
        <b-col>
          <multiselect v-model="commissionFee.comission" :max-height="200"
                       placeholder="" label="description" track-by="id"
                       :disabled="!commissionFee.agent"
                       :options="commissionFee.agentCommissions"
                       @select="selectCommission"
                       :close-on-select="true"></multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <label>{{$t('labels.agents.commission_type')}}</label>
        </b-col>
        <b-col>
          <multiselect v-model="commissionFee.type" :max-height="200"
                       placeholder="" label="name" track-by="name"
                       :options="commissionTypes" :close-on-select="true"
                       :class="{ required: !commissionFee.type}"
                       @input="autoCompleteCurrency"
                       ></multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <label>{{$t('labels.agents.commission_currency')}}</label>
        </b-col>
        <b-col>
          <multiselect v-model="commissionFee.currency" :max-height="200"
                       placeholder="" label="code" track-by="code"
                       :class="{ required: !commissionFee.currency}"
                       :disabled="!commissionFee.type || isCommCurrencyNotEditable"
                       :options="currencies" :close-on-select="true"></multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <label>{{$t('labels.agents.commission_uom')}}</label>
        </b-col>
        <b-col>
          <multiselect v-model="commissionFee.measure_type" :max-height="200"
                       placeholder=""
                       :disabled="!commissionFee.type || !isCommTypeCurrUom"
                       :class="{ required: !commissionFee.measure_type && commissionFee.type && isCommTypeCurrUom}"
                       :options="measure_types" :close-on-select="true"></multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <label>{{$t('labels.common.wood')}}</label>
        </b-col>
        <b-col>
          <multiselect v-model="commissionFee.trees" :max-height="200" :searchable="true"
                       label="name" track-by="name" :options="wood"
                       :multiple="true" :close-on-select="false"
                       :disabled="!commissionFee.type || !isCommTypeCurrUom"
                       placeholder=""
          ></multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <label>{{$t('labels.common.product_group')}}</label>
        </b-col>
        <b-col>
          <multiselect v-model="commissionFee.product_group" :max-height="200" :searchable="true"
                       label="name" track-by="name" :options="movement_groups"
                       :multiple="true" :close-on-select="false"
                       :disabled="!commissionFee.product_group || !(isCommTypeCurrUom || isCommTypeSumm)"
                       placeholder=""
          ></multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <label>{{$t('labels.agents.commission_value')}}</label>
        </b-col>
        <b-col>
          <input class="form-control" placeholder=""
                 v-digits-after-decimal="{numberOfDigits: 2}"
                 :disabled="!commissionFee.type"
                 :class="{ required: !commissionFee.value && commissionFee.type}"
                 v-model="commissionFee.value">
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <label>{{$t('labels.agents.commission_sum')}}</label>
        </b-col>
        <b-col>
          <input class="form-control"
                 v-model="commissionFee.sum" disabled>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <label>{{$t('labels.common.notes')}}</label>
        </b-col>
        <b-col>
          <b-form-textarea class="form-control" placeholder=""
            v-model="commissionFee.notes" />
        </b-col>
      </b-row>
      <div slot="modal-footer" class="w-100 text-right">
        <b-btn size="sm" variant="success" @click="save" :disabled="saved">
          {{$t('buttons.common.save')}}
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect';
  import {
    mapState
  } from 'vuex';
  import {getArrayByProperty, handlerResponse} from '@/helpers/commonHelpers';
  import {notificationsRenderer} from '@/helpers/renderHelpers';

  export default {
    props: ['invoiceId', 'saveCommissionFeeCb', 'invoiceData'],
    components: {
      Multiselect
    },
    created () {
      console.log(this.invoiceData)
    },
    data() {
      return {
        saved: false,
        commissionFeeInitial: {
          agent: '',
          agentCommissions: [],
          comission: '',
          type: '',
          currency: '',
          measure_type: null,
          trees: [],
          product_group: [],
          value: '',
          sum: '',
          notes: ''
        },
        commissionFee: {}
      }
    },
    computed: {
      ...mapState('generic', ['currencies', 'commissionTypes']),
      ...mapState('woodware', ['measure_types', 'wood', 'base_currency', 'movement_groups']),
      ...mapState('partners', ['agents']),
      title() {
        return this.$t('modal_dialogs.partner.commission');
      },
      isNewCommissionFee() {
        return !this.commissionFee.id;
      },
      isCommTypeSumm() {
        return this.commissionFee.type && (this.commissionFee.type.key === '%(inv-tr)' || this.commissionFee.type.key === '%(inv)')
      },
      isCommCurrencyNotEditable() {
        return this.commissionFee.type && !(this.commissionFee.type.key === 'crncy|uom' || this.commissionFee.type.key === 'fix');
      },
      isCommTypeCurrUom() {
        return this.commissionFee.type && (this.commissionFee.type.key === 'crncy|uom');
      },
    },
    methods: {
      async save() {
        let saveData = {
          agent: this.commissionFee.agent ? this.commissionFee.agent.id : null,
          commission_type: this.commissionFee.type ? this.commissionFee.type.key : null,
          currency: this.commissionFee.currency ? this.commissionFee.currency.id : null,
          measure_type: this.commissionFee.measure_type,
          trees: getArrayByProperty(this.commissionFee.trees, 'id'),
          product_group: getArrayByProperty(this.commissionFee.product_group, 'id'),
          purchase_invoice: this.invoiceId,
          value: this.commissionFee.value,
          notes: this.commissionFee.notes
        };
        this.saved = true
        try {
          let payload;
          if(this.isNewCommissionFee) {
            payload = await this.$http.post(`accounting/purchase_agent_commission_fees/`, saveData).then(handlerResponse);
          } else {
            payload = await this.$http.put(`accounting/purchase_agent_commission_fees/${this.commissionFee.id}/`, saveData).then(handlerResponse);
          }
          this.commissionFee.sum = payload && payload.sum;
          await this.saveCommissionFeeCb();
        } catch(e) {
          this.saved = false
          notificationsRenderer(e.data, 'error')
        }
      },
      async selectAgentCommissions(agent) {
        await this.$http.get(`accounting/purchase_agent_commissions_list/`, {params: {agent_id: agent.id}}).then(handlerResponse).then((response) => {
          this.commissionFee.agentCommissions = response;
        })
      },
      async selectCommission(commission) {
        const payload = await this.$http.get(`accounting/purchase_agent_commissions/${commission.id}`).then(handlerResponse);
        this.commissionFee.value = payload.value;
        this.commissionFee.measure_type = payload.measure_type;
        this.commissionFee.currency = payload.currency;
        this.commissionFee.trees = payload.trees;
        this.commissionFee.product_group = payload.product_group;
        this.commissionFee.type = payload.type;
      },
      autoCompleteCurrency() {
        if (this.isCommTypeSumm) {
          //set EUR as default currency
          this.commissionFee.currency = this.currencies.find(e => e.id === 1);
        }
      },
      loadSettings() {
        this.$store.cache.dispatch('partners/getPurchaseAgents');
        this.$store.cache.dispatch('generic/getCurrencies');
        this.$store.cache.dispatch('generic/loadCommissionTypes', 'purchase_agent');
        this.$store.cache.dispatch('woodware/getWood');
        this.$store.cache.dispatch('woodware/loadMovementGroups');
      },
      async getCommissionData() {
        const response = await this.$http.get(`accounting/purchase_agent_commission_fees/${this.commissionFee.id}/`).then(handlerResponse);
        this.commissionFee.agent = response.agent;
        await this.selectAgentCommissions(this.commissionFee.agent);
        this.commissionFee.type = response.commission_type;
        this.commissionFee.currency = response.currency;
      }
    },
    mounted() {
      this.$root.$on('openPurchaseAgentsInvoiceCommissionFeeModal', async (commissionFee) => {
        this.saved = false
        await this.loadSettings();
        if (commissionFee) {
          this.commissionFee = {...this.commissionFeeInitial, ...commissionFee};
          await this.getCommissionData();
        } else {
          this.commissionFee = {...this.commissionFeeInitial};
        }
        if (this.$refs['purchaseAgentsInvoiceCommissionFeeModal']) {
          this.$refs['purchaseAgentsInvoiceCommissionFeeModal'].show();
        }
      })
    },
    beforeDestroy() {
      this.$root.$off('openPurchaseAgentsInvoiceCommissionFeeModal');
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/PurchaseAgentsInvoiceCommissionFeeModal.vue